
/* injects from baggage-loader */
require('./style.styl');

import React, {Component} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Multiselect from 'components/Multiselect'

export default class Filter extends Component {
  static propTypes = {
    options: PropTypes.array,
    className: PropTypes.string,
    addIcon: PropTypes.string,
    values: PropTypes.array,
    onChange: PropTypes.func
  }

  render() {
    const {options, values, className, addIcon} = this.props

    const classNames = classnames('filter', className, {
      'with-values': values && values.length
    })

    const disabled = !options || !options.length || options.length === 1

    return (
      <div className={classNames}>
        <Multiselect
          disabled={disabled}
          options={options}
          values={values}
          addIcon={addIcon}
          groupCount={this.getGroupCount()}
          onChange={this.onApplyValues}
          contentClassName='filter_multiselect-content'
        />
      </div>
    )
  }

  onApplyValues = values => {
    const {onChange} = this.props

    onChange && onChange(values)
  }

  getGroupCount() {
    const {options} = this.props
    const size = options && options.length

    if (!options || size <= 8) return null

    if (size <= 32) return 8

    return Math.ceil(size / 4)
  }
}



// WEBPACK FOOTER //
// ./client/components/Filter/index.js